import classNames from "classnames";
import { memo } from "react";
import * as loadingRedoAnimationCss from "./loading-redo-animation.module.css";
import { Spinner, SpinnerStyle } from "./spinner";

export const LoadingRedoAnimation = memo(function LoadingRedoAnimation({
  style,
  className,
  dataUi,
}: {
  style?: SpinnerStyle;
  className?: string;
  dataUi?: string;
}) {
  return (
    <div
      className={classNames(loadingRedoAnimationCss.loadingSpinner, className)}
      data-ui={dataUi}
      data-web="LoadingRedoAnimation"
    >
      <div className={loadingRedoAnimationCss.spinnerContainer}>
        <Spinner style={style} />
      </div>
    </div>
  );
});
